const binding = { modules: {}, dataActions: {} };

    (binding.modules['ext-tile-list'] = {
        c: () => require('partner/modules/ext-tile-list/ext-tile-list.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'ext-tile-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/ext-tile-list'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|ext-tile-list|ext-tile-list'] = {
                c: () => require('partner/modules/ext-tile-list/ext-tile-list.view.tsx'),
                cn: '__local__-__local__-ext-tile-list'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };